import type { Nullable, Tables } from "../types";

/**
 * This function is used to determine the role of an organization in a partnership.
 * @param orgId
 * @param partnership
 * @returns
 */
export function getPartnershipRole(
	orgId: Nullable<string>,
	partnership: Nullable<Tables<"organizationPartnerships">>,
) {
	if (!orgId) return null;
	if (!partnership) return null;
	const hostOrgId = partnership?.hostOrgId;
	const partnerOrgId = partnership?.partnerOrgId;
	if (!hostOrgId || !partnerOrgId) return null;
	if (orgId === hostOrgId) return "host";
	if (orgId === partnerOrgId) return "partner";
	return null;
}
